import { useState, useCallback } from "react"

export function useReloadKey() {
  const [state, setState] = useState(1)

  const triggerReload = useCallback(() => setState(state => state + 1), [])

  return [state, triggerReload] as const
}
